/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterItemsQueryVariables = Types.Exact<{
  matterId: Types.Scalars["String"]["input"];
}>;

export type GqlMatterItemsQuery = {
  __typename: "Query";
  matterItems?: Array<{
    __typename: "MatterItem";
    type: Types.GqlMatterItemType;
    id?: string | null;
    name?: string | null;
    role?: string | null;
    isClient?: boolean | null;
    isOtherSide?: boolean | null;
    contact?: { __typename: "Contact"; id: string } | null;
    subItems?: Array<{
      __typename: "MatterItem";
      type: Types.GqlMatterItemType;
      id?: string | null;
      name?: string | null;
      role?: string | null;
      isClient?: boolean | null;
      isOtherSide?: boolean | null;
      contact?: { __typename: "Contact"; id: string } | null;
    } | null> | null;
  }> | null;
};

export const MatterItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "matterItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "matterId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "matterItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "matterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "matterId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "matterItemFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterItemFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "isClient" } },
          { kind: "Field", name: { kind: "Name", value: "isOtherSide" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subItems" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "isClient" } },
                { kind: "Field", name: { kind: "Name", value: "isOtherSide" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlMatterItemsQuery, GqlMatterItemsQueryVariables>;
